import React from 'react'
import IconAspectRatio from '../../icons/toolbar/menu/crop/AspectRatio'
import IconFreeCrop from '../../icons/toolbar/menu/crop/FreeCrop'
import IconNoFrame from '../../icons/toolbar/menu/crop/NoFrame'
import IconYoutube from '../../icons/toolbar/menu/crop/Youtube'

const ITEMS = [
  { id: 8, icon: 'free-crop', text: 'Free Crop', value: '' },
  { id: 2, icon: 'one-one', text: '1:1', value: 1 },
  { id: 3, icon: 'four-five', text: '4:5', value: 4 / 5 },
  { id: 4, icon: 'video', text: '16:9', value: 16 / 9 },
  { id: 5, icon: 'real', text: '9:16', value: 9 / 16 },
  { id: 6, icon: 'cover-photo', text: 'Cover Photo', value: 2.63 / 1 },
]

export default class CropMenu extends React.Component {
  constructor(props) {
    super(props)

    let aspectRatio = props.aspectRatio || ITEMS[0].value

    this.state = {
      selectedItem: ITEMS.find(item => item.value == aspectRatio),
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  render() {
    let { selectedItem } = this.state
    return (
      <div className="crop-menu">
        <div className="items">
          {ITEMS.map((item) => (
            <div
              key={item.id}
              className={`item ${item.icon} ${
                selectedItem.id === item.id ? 'active' : ''
              }`}
              onClick={() => {
                this.setState({ selectedItem: item })
                this.props.onAspectRatioChanged(item)
              }}
            >
              <div className={`asset ${item.icon}`}>
                {item.icon === 'noframe' && <IconNoFrame />}
                {(item.icon === 'one-one' || item.icon === 'four-five') && (
                  <IconAspectRatio />
                )}
                {(item.icon === 'video' || item.icon === 'real') && (
                  <IconYoutube />
                )}
                {item.icon === 'free-crop' && <IconFreeCrop />}
              </div>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    )
  }
}
